import { createContext, RefObject, use } from "react";

export const AlertContext = createContext<{ ref: RefObject<HTMLElement | null> | undefined }>({
  ref: undefined,
});
export function useAlertRef() {
  return use(AlertContext).ref;
}
